<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Line Messenger" class="d-icon d-icon--line-messenger" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-rule="evenodd" fill-rule="evenodd"><path d="M6.093 2h11.814A4.105 4.105 0 0 1 22 6.093v11.814A4.105 4.105 0 0 1 17.907 22H6.093A4.105 4.105 0 0 1 2 17.907V6.093A4.105 4.105 0 0 1 6.093 2z" fill="#3ace01"/><path d="M11.98 5.313c4.053 0 7.338 2.63 7.338 5.876 0 1.133-.401 2.191-1.095 3.089-.035.05-.08.107-.136.17l-.004.004a6.53 6.53 0 0 1-.798.797c-2.03 1.875-5.37 4.108-5.81 3.763-.383-.299.63-1.764-.54-2.007a9.542 9.542 0 0 1-.243-.031h-.002c-3.437-.489-6.047-2.893-6.047-5.785 0-3.245 3.285-5.876 7.338-5.876z" fill="#fff"/><path d="M7.723 13.063h1.48c.21 0 .383-.173.383-.383v-.032a.384.384 0 0 0-.383-.383H8.138V9.842a.384.384 0 0 0-.383-.383h-.032a.384.384 0 0 0-.382.383v2.838c0 .21.172.383.382.383zm9.17-1.78v-.031a.384.384 0 0 0-.383-.383h-1.065v-.606h1.065a.384.384 0 0 0 .383-.383v-.032a.384.384 0 0 0-.383-.382h-1.48a.384.384 0 0 0-.382.382v2.839c0 .21.172.382.383.382h1.48c.21 0 .382-.172.382-.382v-.032a.384.384 0 0 0-.383-.383h-1.065v-.606h1.065a.383.383 0 0 0 .383-.382zm-2.846 1.666a.382.382 0 0 0 .111-.269V9.842a.384.384 0 0 0-.383-.383h-.032a.384.384 0 0 0-.382.383v1.666l-1.384-1.855a.383.383 0 0 0-.332-.194h-.032a.384.384 0 0 0-.382.383v2.838c0 .21.172.383.382.383h.032c.21 0 .383-.173.383-.383v-1.697l1.393 1.903a.388.388 0 0 0 .028.038c.038.052.09.088.15.11a.38.38 0 0 0 .144.029h.032a.38.38 0 0 0 .18-.045.27.27 0 0 0 .092-.07zm-3.77.114h.032c.21 0 .383-.173.383-.383V9.842a.384.384 0 0 0-.383-.383h-.032a.384.384 0 0 0-.382.383v2.838c0 .21.172.383.382.383z" fill="#3ace01"/></g></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconLineMessenger',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
